import axios from 'axios';
import router from "../router";
import { ElMessage } from 'element-plus';
// 创建axios
const $axios = axios.create({
    // baseURL: defaultUrl,
    timeout: 30000,
    withCredentials: false,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        // "Content-Type": "application/json;charset=UTF-8",
        // "Origin": "https://backend.p2ipo.com",
        "Access-Control-Allow-Origin": "https://backend.p2ipo.com/index.php",
        // "Access-Control-Allow-Headers": "X-Requested-With,Content-Type",
        // "Access-Control-Allow-Credentials": true,
        // "Content-Type": "multipart/form-data"
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    }
});
// $axios.defaults.transformRequest = [function (data) {
//     let ret = '', arr = [];
//     console.log('data>>>', data)
//     for (let it in data) {
//         if(!Array.isArray(data[it]) && typeof data[it] != 'object') {
//             arr.push(encodeURIComponent(it) + '=' + encodeURIComponent(data[it]));
//         } else {
//             arr.push(encodeURIComponent(it) + '=' + JSON.stringify(data[it]));
//         }
//         ret = arr.join('&');
//     }
//     console.log('ret>>>', ret)
//     return ret;
// }];
// 请求拦截器
$axios.interceptors.request.use((config: any) => {
    // console.log('config>>>', config);
    let token = window.localStorage.getItem('_TOKEN_');
    config.headers.Authorization = token ? 'Bearer ' + token : 'Bearer';
    // if(config.method == 'get') {
    //     config.paramsSerializer = function(params: any) {
    //         return this.$qs.stringify(params, { arrayFormat: 'repeat' });
    //     }
    // }
    return config;
}, error => {
    return Promise.reject(error);
});
// 响应拦截器
$axios.interceptors.response.use(response => {
    // console.log('response>>>', response);
    // switch (response.status) {
    //     case 401: // token已过期
    //         ElMessage.error(response.data.message);
    //         router.push({ path: '/login' });
    //         return;
    //     default:
    //         break;
    // }
    return response.data;
}, error => {
    // console.log('error>>>', error.response);
    ElMessage.error(error.response.data.message);
    switch (error.response.status) {
        case 401: // token已过期
            window.localStorage.setItem('_TOKEN_', '');
            window.sessionStorage.setItem('_MENU_ACTIVE_', '');
            router.push({ path: '/login' });
            return;
        case 500: // 服务器错误
        default:
            break;
    }
    return error.response.data;
    // return Promise.reject(error);
});
export default $axios;